module.exports = __webpack_public_path__ + "static/media/Plus2BreathingActivity.a726b35e.mp3";